export default __webpack_public_path__ + "static/media/image_full_100.7e1432e6.svg";